import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { WindowRef } from '@spartacus/core'
import { isPlatformServer } from '@angular/common'

export interface ScriptSources {
  links?: (Partial<HTMLLinkElement>)[];
  scripts?: (Partial<HTMLScriptElement>)[];
}

@Injectable({
  providedIn: 'root'
})
export class ScriptsService {

  isInit = false

  constructor (protected winRef: WindowRef,
              @Inject(PLATFORM_ID) protected platformId: any) {
  }

  init (sources: ScriptSources) {
    if (!isPlatformServer(this.platformId)) {
      if (!this.isInit) {
        this.isInit = true
        const { document } = this.winRef
        for (const link of sources.links || []) {
          if (link.href) {
            const tag = document.createElement('link') as any
            Object.keys(link).forEach(k => tag[k] = (link as any)[k])
            document.head.appendChild(tag) // since it's a service we don't have renderer2
          }
        }
        for (const script of sources.scripts || []) {
          if (script.src) {
            const tag = document.createElement('script') as any
            Object.keys(script).forEach(k => {
              try {
                tag[k] = (script as any)[k]
              } catch (_) {
              }
            })
            if (script.dataset) {
              Object.keys(script.dataset).forEach(k => {
                tag.dataset[k] = script.dataset?.[k]
              })
            }
            document.body.appendChild(tag)
          }
        }
      }
    }
  }
}
